var map = {
	"./API/ApiTokenManager": 2693,
	"./API/ApiTokenManager.vue": 2693,
	"./API/Index": 4197,
	"./API/Index.vue": 4197,
	"./Auth/ConfirmPassword": 5362,
	"./Auth/ConfirmPassword.vue": 5362,
	"./Auth/ForgotPassword": 6229,
	"./Auth/ForgotPassword.vue": 6229,
	"./Auth/Login": 9146,
	"./Auth/Login.vue": 9146,
	"./Auth/Register": 7795,
	"./Auth/Register.vue": 7795,
	"./Auth/ResetPassword": 5712,
	"./Auth/ResetPassword.vue": 5712,
	"./Auth/TwoFactorChallenge": 2459,
	"./Auth/TwoFactorChallenge.vue": 2459,
	"./Auth/VerifyEmail": 8546,
	"./Auth/VerifyEmail.vue": 8546,
	"./Dashboard": 8222,
	"./Dashboard.vue": 8222,
	"./Main/About": 9918,
	"./Main/About.vue": 9918,
	"./Main/Database": 5022,
	"./Main/Database.vue": 5022,
	"./Main/Game": 3345,
	"./Main/Game.vue": 3345,
	"./Main/Home": 3426,
	"./Main/Home.vue": 3426,
	"./Main/MiniGames": 6606,
	"./Main/MiniGames.vue": 6606,
	"./Main/Publication": 3576,
	"./Main/Publication.vue": 3576,
	"./MiniGames/Binoculars": 8634,
	"./MiniGames/Binoculars.vue": 8634,
	"./MiniGames/DataCharger": 6340,
	"./MiniGames/DataCharger.vue": 6340,
	"./MiniGames/InterviewSim": 391,
	"./MiniGames/InterviewSim.vue": 391,
	"./MiniGames/Jammr": 9239,
	"./MiniGames/Jammr.vue": 9239,
	"./MiniGames/ParticipatoryLoop": 2258,
	"./MiniGames/ParticipatoryLoop.vue": 2258,
	"./MiniGames/Persona": 6726,
	"./MiniGames/Persona.vue": 6726,
	"./MiniGames/ProtoEscape": 8402,
	"./MiniGames/ProtoEscape.vue": 8402,
	"./MiniGames/Questioniser": 3922,
	"./MiniGames/Questioniser.vue": 3922,
	"./MiniGames/ResearchPaperPlease": 7176,
	"./MiniGames/ResearchPaperPlease.vue": 7176,
	"./PrivacyPolicy": 3697,
	"./PrivacyPolicy.vue": 3697,
	"./Profile/DeleteUserForm": 9473,
	"./Profile/DeleteUserForm.vue": 9473,
	"./Profile/LogoutOtherBrowserSessionsForm": 9993,
	"./Profile/LogoutOtherBrowserSessionsForm.vue": 9993,
	"./Profile/Show": 9391,
	"./Profile/Show.vue": 9391,
	"./Profile/TwoFactorAuthenticationForm": 9430,
	"./Profile/TwoFactorAuthenticationForm.vue": 9430,
	"./Profile/UpdatePasswordForm": 5029,
	"./Profile/UpdatePasswordForm.vue": 5029,
	"./Profile/UpdateProfileInformationForm": 7580,
	"./Profile/UpdateProfileInformationForm.vue": 7580,
	"./ResearchTopics/AddTopic": 8542,
	"./ResearchTopics/AddTopic.vue": 8542,
	"./ResearchTopics/CreatePlan": 8089,
	"./ResearchTopics/CreatePlan.vue": 8089,
	"./ResearchTopics/EditTopic": 8337,
	"./ResearchTopics/EditTopic.vue": 8337,
	"./ResearchTopics/FindTopic": 2218,
	"./ResearchTopics/FindTopic.vue": 2218,
	"./TermsOfService": 9741,
	"./TermsOfService.vue": 9741,
	"./Welcome": 8786,
	"./Welcome.vue": 8786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;